import { ImplementEffectiveConfig } from "protos/atk/effective_config";
import {
  Point,
  projectPolygonOntoGlobe,
} from "common/utils/map/projectPolygonOntoGlobe";
import { Polygon } from "geojson";

export interface ImplementOutline {
  serial: string;
  outline: Polygon;
}

export const createImplementOutline = (
  centerLng: number,
  centerLat: number,
  headingDegrees: number,
  implement: ImplementEffectiveConfig
): Polygon => {
  const boundary = implement.boundary;
  const hitchOffset = implement.activeHitch?.offsetYM;

  let points: Point[] = [];
  if (boundary && boundary.points.length > 0) {
    // Boundary coordinates are defined with +y in the direction of a tractor's forward travel.
    //
    // this is implemented incorrectly in the path planner, that's why we negate it here.
    // The ui will match for now to be consistent, but we need to coordinate on a fix. (same for hitch offsets) TODO
    points = boundary.points.map((p) => [p.x, -p.y]);
  }

  // repeat the last point because thats how polygons work.
  if (points[0]) {
    points.push(points[0]);
  }

  if (hitchOffset) {
    // likewise for hitch offset, the offset's coordinate space has +y downwards.
    points = points.map(([x, y]) => {
      return [x, y - hitchOffset];
    });
  }

  const projectedPoints = projectPolygonOntoGlobe(
    points,
    headingDegrees,
    centerLat,
    centerLng
  );

  return {
    type: "Polygon",
    coordinates: [projectedPoints],
  };
};
